<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Email Templates</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Email Templates</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                data-toggle="modal"
                name="eSms"
                data-target=""
                @click="addEmailClick"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <div class="table-responsive">
            <table
              id="emailList"
              data-height="300"
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
            >
              <thead class="thead-dark">
                <tr>
                  <th>Action</th>
                  <th>Status</th>
                  <th>ID</th>
                  <th>Name</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="em in emailList" :key="em.emailTemplateId">
                  <td>
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        :disabled="updButton == 0"
                        data-target=""
                        @click="emailEditClick(em.emailTemplateId)"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        :disabled="delButton == 0"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          id="emailtempArchive"
                          @click="updateEmailClick(em.emailTemplateId, 2, 'delete')"
                          >Delete</a
                        >
                      </div>
                    </div>
                  </td>
                  <th>
                   <div v-if="em.isStatus == 'Draft'">
                         <span class="bs-label label-warning badgeBorder">
                         {{ em.isStatus }}
                         </span>
                    </div>
                      <div v-if="em.isStatus == 'Approved'">
                         <span class="bs-label label-success badgeBorder">
                         {{ em.isStatus }}
                         </span>
                    </div>
                      <div v-if="em.isStatus == 'Pending'">
                         <span class="bs-label label-warning badgeBorder">
                         {{ em.isStatus }}
                         </span>
                    </div>
                      <div v-if="em.isStatus == 'Rejected'">
                         <span class="bs-label label-danger badgeBorder">
                         {{ em.isStatus }}
                         </span>
                    </div>
                  </th>
                  <th>EID-{{ em.emailTemplateIdSerial }}</th>
                  <th>{{ em.name }}</th>
                  <!-- <th>{{ em.isActive ? "Active" : "Inactive" }}</th> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- Compose Email Modal V2 -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendEmailv2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Add Email Template</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
           <div class="row">
            <div class="col-5">
              <button
              style="margin-top: 17px;margin-left: 53px;"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="saveNewEmail('Draft')"
            >
              Save as Draft
            </button>
              </div>
            <div class="col-2"></div>
            <div class="col-5">
              <button
              style="margin-top: 17px;margin-left: -52px;"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="saveNewEmail('Approval')"
            >
              Save
            </button>
              </div>
            </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">Email</h3>
                         <div class="form-group">
                    <select
                      class="form-control custom-select"
                      @change=setMerge()
                      v-model="mergeValue"
                    >
                     <option value="" selected> Select tag to Insert </option>
                         <option value="@FirstName ">First Name</option>
                          <option value="@LastName ">Last Name</option>
                          <option value="@DOB ">DoB</option>
                          <option value="@Phone ">Phone</option>
                          <option value="@Email ">Email</option>
                          <option value="@DOS ">DOS</option>
                          <option value="@Visit Type ">Visit Type</option>
                          <option value="@Visit Reason ">Visit Reason</option>
                          <option value="@Physician ">Physician</option>
                          <option value="@Street ">Street</option>
                          <option value="@City ">City</option>
                          <option value="@State ">State</option>
                          <option value="@zip ">zip</option>
                          <option value="@Primary Insurance Name ">Primary Insurance Name</option>
                          <option value="@Primary Insurance Number ">Primary Insurance Number</option>
                          <option value="@Primary Insurance Group ID ">Primary Insurance Group ID</option>
                          <option value="@Secondary Insurance Name ">Secondary Insurance Name</option>
                          <option value="@Secondary Insurance Number ">Secondary Insurance Number</option>
                          <option value="@Secondary Insurance Group ID ">Secondary Insurance Group ID</option>
                    </select>
                    </div>

                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name:"
                          maxlength="40"
                          v-model="singleEmail.name"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Subject:"
                          maxlength="200"
                          v-model="singleEmail.emailSubject"
                        />
                      </div>
                       <Mentionable
                      :keys="['@', '#']"
                      :items="items"
                      offset="6"
                      insert-space
                      @open="onOpen"
                    >
                     
                      
                      <template #no-result>
                        <div class="dim">
                          No result
                        </div>
                      </template>

                      <template #item-@="{ item }">
                        <div class="user">
                          {{ item.value }}
                          <span class="dim">
                            ({{ item.firstName }})
                          </span>
                        </div>
                      </template>

                      <template #item-#="{ item }">
                        <div class="issue">
                          <span class="number">
                            #{{ item.value }}
                          </span>
                          <span class="dim">
                            {{ item.label }}
                          </span>
                        </div>
                      </template>
                    </Mentionable>
                      <Editor v-model="singleEmail.emailText" editorStyle="height: 200px"/>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Compose Email Modal V2 -->

    <!-- Update a Text Modal v2 -->
    <div
      class="modal bs-example-modal-lg fade"
      id="updateTextv2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Update Email Template</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
             <div class="row">
            <div class="col-5">
            <button
              style="margin-top: 17px;margin-left: 53px;"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="updateEmailClick(singleEmail.emailTemplateId, 1, 'Draft')"
            >
              Save as Draft
            </button>
              </div>
            <div class="col-2"></div>
            <div class="col-5">
             <button
              style="margin-top: 17px;margin-left: -52px;"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="updateEmailClick(singleEmail.emailTemplateId, 1, 'Approval')"
            >
              Submit for Approval
            </button>
              </div>
            </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">Email</h3>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name"
                          maxlength="40"
                          v-model="singleEmail.name"
                        />
                      </div>

                   <div class="form-group">
                    <select
                      class="form-control custom-select"
                      @change=setMerge1()
                      v-model="mergeValue1"
                    >
                     <option value="" selected> Select tag to Insert </option>
                          <option value="@FirstName ">First Name</option>
                          <option value="@LastName ">Last Name</option>
                          <option value="@DOB ">DoB</option>
                          <option value="@Phone ">Phone</option>
                          <option value="@Email ">Email</option>
                          <option value="@DOS ">DOS</option>
                          <option value="@Visit Type ">Visit Type</option>
                          <option value="@Visit Reason ">Visit Reason</option>
                          <option value="@Physician ">Physician</option>
                          <option value="@Street ">Street</option>
                          <option value="@City ">City</option>
                          <option value="@State ">State</option>
                          <option value="@zip ">zip</option>
                          <option value="@Primary Insurance Name ">Primary Insurance Name</option>
                          <option value="@Primary Insurance Number ">Primary Insurance Number</option>
                          <option value="@Primary Insurance Group ID ">Primary Insurance Group ID</option>
                          <option value="@Secondary Insurance Name ">Secondary Insurance Name</option>
                          <option value="@Secondary Insurance Number ">Secondary Insurance Number</option>
                          <option value="@Secondary Insurance Group ID ">Secondary Insurance Group ID</option>
                    </select>
                    </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Subject"
                          maxlength="200"
                          v-model="singleEmail.emailSubject"
                        />
                      </div>
                      <Editor v-model="singleEmail.emailText1" editorStyle="height: 200px"/>
                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Update a Text Modal v2 -->
  </div>
</template>

<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import { Mentionable } from 'vue-mention'
import 'floating-vue/dist/style.css'
import "mosha-vue-toastify/dist/style.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  name: "emailTemplates",
  components: {
    Mentionable,
  },
  data() {
    return {
        text: '',
      items: [],
      users : [
        {
          value: 'akryum',
          firstName: 'Guillaume',
        },
        {
          value: 'posva',
          firstName: 'Eduardo',
        },
        {
          value: 'atinux',
          firstName: 'Sébastien',
        },
      ],
      issues : [
        {
          value: 123,
          label: 'Error with foo bar',
          searchText: 'foo bar'
        },
        {
          value: 42,
          label: 'Cannot read line',
          searchText: 'foo bar line'
        },
        {
          value: 77,
          label: 'I have a feature suggestion',
          searchText: 'feature'
        }
      ],
      practName: "",
      practAdd: "",
      userNme: "",
      userEmal: "",
      rtpD: "",

      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      mergeValue: '',
      mergeValue1: '',

      //loader
      loader: "",
      //Timer
      TimerObject: {},
      emailList: [],
      singleEmail: {
        name: "",
        emailSubject: "",
        emailText: "",
        emailText1: "",
      },
      content: "",
    };
  }, // data

methods: {    
   onOpen (key) {
      this.items = key === '@' ? this.users : this.issues
    },
 setMerge() {
 //debugger
  var e = $(".ql-editor")[0];
      if( document.getSelection().baseNode.data){
        var selectedData = document.getSelection().baseNode.data;
      var changeNode = document.getSelection().baseNode.data;
      var selectedIndex = document.getSelection().focusOffset  ;

    if(selectedData.length <=  selectedIndex){
          selectedIndex = selectedData.length;
      }
     selectedData =[selectedData.slice(0, selectedIndex),this.mergeValue,selectedData.slice(selectedIndex)].join("")
       this.singleEmail.emailText = this.singleEmail.emailText.replace(changeNode,selectedData);
      }else{
       this.singleEmail.emailText =  this.singleEmail.emailText + " " + this.mergeValue;
      }
    },

    setMerge1() {
      var e = $(".ql-editor")[1];
       if( document.getSelection().baseNode.data){
       var selectedData = document.getSelection().baseNode.data;
      var changeNode = document.getSelection().baseNode.data;
      var selectedIndex = document.getSelection().focusOffset  ;

      if(selectedData.length <=  selectedIndex){
          selectedIndex = selectedData.length;
        }
      selectedData =[selectedData.slice(0, selectedIndex),this.mergeValue1,selectedData.slice(selectedIndex)].join("")
     // selectedData = selectedData.splice(selectedIndex ,0, this.mergeValue1);
     this.singleEmail.emailText1 = this.singleEmail.emailText1.replace(changeNode,selectedData);}
      else{
        this.singleEmail.emailText1 = this.singleEmail.emailText1 + " " + this.mergeValue1;
      }
    },

handleRole(){
   this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
   if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Email Template'
     );
       if(this.val[0].canUpdate == 0){ this.updButton = 0;}
       if(this.val[0].canDelete == 0){ this.delButton = 0;}
       if(this.val[0].canCreate == 0){$('button[name=eSms]').hide();}
}
},

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    updateEmailClick(id, what, status) {
     //debugger // eslint-disable-line no-debugger
      console.log(this.singleEmail);
      let passData = {};
      if(this.singleEmail.name == "" && status !=="delete"){
        this.ShowWarning("Please Add a Template");
        return;
      }
      if(this.singleEmail.emailSubject == ""  && status !=="delete"){
        this.ShowWarning("Please Add a Subject");
        return;
      }
      if(this.singleEmail.emailText1 == ""  && status !=="delete"){
        this.ShowWarning("Please Enter Some Tetx");
        return;
      }
    if(status == 'Draft'){
      this.singleEmail.isStatus = 'Draft';

      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY + what;
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.dummyComm.patientId = arr[0];
      console.log("single payment-00111-222: ", this.dummy);
      passData = {
        dc: this.dummyComm,
        etmp: this.singleEmail,
      };
    } else if(status == 'delete'){
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY + what;
      console.log("single payment-00111-222: ", this.dummy);
      passData = {
        dc: this.dummyComm,
        etmp: this.singleEmail,
      };
    } else{
      this.singleEmail.isStatus = 'Pending';

      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY + what;
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.dummyComm.patientId = arr[0];
      this.singleEmail.PracticeName = this.practName;
      this.singleEmail.PracticeAddress = this.practAdd;
      this.singleEmail.RTPId = this.rtpD;
      this.singleEmail.UserName = this.userNme;
      this.singleEmail.Email = this.userEmal;
      console.log("single payment-00111-222: ", this.dummy);
      passData = {
        dc: this.dummyComm,
        etmp: this.singleEmail,
      };
    }
    
    var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/UPDEMLTMP",
        data: passData,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            if (what == 1) $("#updateTextv2").modal("hide");
            this.loadInit();
            //this.$forceUpdate();
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    },

    addEmailClick() {
      this.singleEmail.name = "";
      this.singleEmail.emailSubject = "";
      this.singleEmail.emailText = "";
      $("#sendEmailv2").modal("show");
    },
    saveNewEmail(status) {
      let passData = {};
      if(status == 'Draft'){
       if(this.singleEmail.name == ""){
        this.ShowWarning("Please Add a Template");
        return;
      }
      if(this.singleEmail.emailSubject == ""){
        this.ShowWarning("Please Add a Subject");
        return;
      }
      if(this.singleEmail.emailText == ""){
        this.ShowWarning("Please Enter Some Tetx");
        return;
      }
      this.intDummyComm();
      this.singleEmail.isStatus = 'Draft';
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.dummyComm.patientId = arr[0];
      passData = {
        dc: this.dummyComm,
        etmp: this.singleEmail,
        isStatus: 'Draft'
      };
    } else{
       if(this.singleEmail.name == ""){
        this.ShowWarning("Please Add a Template");
        return;
      }
      if(this.singleEmail.emailSubject == ""){
        this.ShowWarning("Please Add a Subject");
        return;
      }
      if(this.singleEmail.emailText == ""){
        this.ShowWarning("Please Enter Some Tetx");
        return;
      }
      this.intDummyComm();
      this.singleEmail.isStatus = 'Approved';
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.dummyComm.patientId = arr[0];
      this.singleEmail.PracticeName = this.practName;
      this.singleEmail.PracticeAddress = this.practAdd;
      this.singleEmail.RTPId = this.rtpD;
      this.singleEmail.UserName = this.userNme;
      this.singleEmail.Email = this.userEmal;
      passData = {
        dc: this.dummyComm,
        etmp: this.singleEmail
      };
    }
      //alert(passData.question + '      ' + this.quest.question);
       var loader = this.$loading.show({
        // Optional parameters
          color: '#03a9f3'
        });
      axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/ADDEML",
        data: passData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
             //debugger// eslint-disable-line no-debugger
            this.dummy = "";
            this.content = "";
            this.singleEmail.emailText = "";
            this.singleEmail.emailSubject = "";
            this.singleEmail.name = "";
            createToast("Information Added", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            $("#sendEmailv2").modal("hide");
            this.loadInit();
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => { 
          this.ResetLogoutTime();
          loader.hide(); });
    },
    emailEditClick(id) {
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTSNGEMLTMP";

      this.axiosGetData(url, 2);
    },

   loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
   },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = this.myTitle + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTMLST";

      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            $("#emailList").DataTable().destroy();
            this.emailList = res.data.eList;
          } else if (what === 2) {
            this.singleEmail = res.data.etmp;
            this.singleEmail.emailText1 = this.singleEmail.emailText;
            $("#updateTextv2").modal("show");
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {loader.hide(); this.ResetLogoutTime();});
    }, // axiosGetData
  }, // methods
  // computed: {
  //   editor() {
  //       return this.$refs.myQuillEditor.quill
  //     }
  //   },
  mounted() {
    clearTimeout(this.loadObj);
   //debugger
    this.practName = localStorage.getItem('PracticeName');
    this.practAdd = localStorage.getItem('PracticeAddress');
    this.rtpD = localStorage.getItem("RTPID");
    this.userNme = localStorage.getItem("UserName");
    this.userEmal = localStorage.getItem("Email");
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
      clearTimeout(this.TimerObject);
    },

  watch: {
    emailList: function () {
      try {
        this.$nextTick(() => {
          $("#emailList").DataTable().destroy();
          $("#emailList").DataTable({
           pageLength: 50,
            lengthMenu: [
              [50, 100, 500, 1000, 2000],
              [50, 100, 500, 1000, 2000],
            ],
          });
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $("#emailList").DataTable().draw();
        });
      } catch {
        alert("catch");
      }
    },
  },
};
</script>


<style>
</style>